export default "<p>scanner works!</p>\r\n"